export const attendancesKeys = {
    ATTENDANCES_CREATE: 'attendance/create',
    ATTENDANCES_UPDATE: 'attendance/update',
    ATTENDANCES_DELETE: 'attendance/delete',
    ATTENDANCES_READ: 'attendance/read',
};